import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-points"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "enemy",
    style: _normalizeStyle([
      {
        transform: _ctx.leftright
          ? 'translate(' +
            _ctx.selfposition.left +
            'px,' +
            _ctx.selfposition.top +
            'px) rotate(90deg)'
          : 'translate(' + _ctx.selfposition.left + 'px,' + _ctx.selfposition.top + 'px)',
      },
      { width: _ctx.difficulty.size + 'px' },
      { height: _ctx.difficulty.size + 'px' },
    ]),
    ref: "enemyElement",
    "data-points": _ctx.difficulty.points
  }, [
    _createElementVNode("img", {
      src: _ctx.difficulty.src,
      class: "enemy_img"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ], 12, _hoisted_1))
}